import { config as allConfigs } from "./configs";

export const config = allConfigs.configs[process.env.REACT_APP_ENV ?? "dev"];
